module.exports = __webpack_public_path__ + "img/tijian_img2.818a2de4.png";